import { createContext, useContext, useEffect, useState } from "react";

// Full bilingual dictionary. Keys are stable; values may be tweaked freely.
const STRINGS = {
  en: {
    // ─── Navigation ──────────────────────────────
    "nav.dashboard": "Dashboard",
    "nav.trips": "Trips",
    "nav.find_trips": "Find Trips",
    "nav.my_trips": "My Trips",
    "nav.requests": "Requests",
    "nav.browse_requests": "Browse Requests",
    "nav.my_requests": "My Requests",
    "nav.catalog": "My Catalog",
    "nav.admin": "Admin Console",
    "nav.sign_in": "Sign In",
    "nav.sign_out": "Sign Out",
    "nav.profile": "Profile",
    // ─── Bottom Nav ──────────────────────────────
    "bnav.home": "Home",
    "bnav.trips": "Trips",
    "bnav.requests": "Requests",
    "bnav.catalog": "Catalog",
    // ─── Auth ────────────────────────────────────
    "auth.welcome_back": "Welcome back",
    "auth.create_account": "Create Account",
    "auth.join": "Join Jastip-Safe",
    "auth.sign_in": "Sign in",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.full_name": "Full Name",
    "auth.phone": "Phone Number",
    "auth.location": "Origin Location (City/Province)",
    "auth.referral_label": "Referral Code (optional)",
    "auth.referral_placeholder": "e.g. andi-jastip",
    "auth.unified_note": "One account = Buyer AND Jastiper. You can switch mode anytime from the header after login.",
    "auth.creating": "Creating...",
    "auth.signing_in": "Signing in...",
    "auth.no_account": "No account yet?",
    "auth.already_account": "Already have an account?",
    "auth.create_one": "Create one",
    "auth.otp_title": "Enter OTP code",
    "auth.otp_sent_to": "Code sent to",
    "auth.verify_continue": "Verify & Continue",
    "auth.back_login": "Back to login",
    "auth.privacy_label": "Default Catalog Price Visibility",
    "auth.privacy_public": "Public",
    "auth.privacy_public_desc": "Prices visible",
    "auth.privacy_hide": "Hide Price",
    "auth.privacy_hide_desc": "Anti price-war",
    "auth.privacy_hint": "Can be changed anytime in Profile.",
    "auth.password_hint": "Min 8 characters, must contain letters and numbers.",
    "auth.password_strong": "strong",
    "auth.password_weak": "too weak",
    "auth.fill_all": "Please fill all fields",
    "auth.password_invalid": "Password must be at least 8 chars with letters and numbers",
    "auth.otp_sent": "OTP sent! Use code 123456 (demo mode)",
    "auth.register_failed": "Registration failed",
    "auth.welcome_user": "Welcome,",
    "auth.login_failed": "Login failed",
    "auth.account_verified": "Account verified!",
    "auth.otp_wrong": "Wrong OTP code",
    "auth.superadmin_q": "Superadmin platform?",
    "auth.login_admin": "Admin Login",
    "auth.verifying": "Verifying...",
    "auth.demo_mode_note": "DEMO MODE — OTP is:",
    // ─── Dashboard ───────────────────────────────
    "dash.welcome": "Welcome back",
    "dash.hello": "Hello",
    "dash.signed_in_as": "Signed in as",
    "dash.mode_buyer": "Buyer",
    "dash.mode_jastiper": "Jastiper",
    "dash.new_trip": "New Trip",
    "dash.new_request": "New Request",
    "dash.active_buys": "Active Buys",
    "dash.total_buys": "Total Buys",
    "dash.open_requests": "Open Requests",
    "dash.trips_available": "Trips Available",
    "dash.active_shipping": "Active Shipping",
    "dash.active_trips": "Active Trips",
    "dash.your_trips": "Your Trips",
    "dash.my_active_trips": "My Active Trips",
    "dash.my_active_trips_desc": "Click a trip to view details & manage its catalog.",
    "dash.no_my_trips": "No active trips yet. Create your first one.",
    "dash.trip_active_badge": "Active",
    "dash.manage_catalog_arrow": "Manage catalog →",
    "dash.pending_earnings": "Pending Earnings",
    "dash.total_earned": "Total Earned",
    "dash.my_orders": "My Orders",
    "dash.shipping": "Shipping",
    "dash.discover": "Discover",
    "dash.earn": "Earn",
    "dash.discover_trips": "Jastipers traveling now",
    "dash.discover_trips_desc": "Browse active trips and order from their catalog.",
    "dash.discover_requests": "Open Buyer Requests",
    "dash.discover_requests_desc": "Accept a request and start shopping for a buyer.",
    "dash.view_all": "View all",
    "dash.no_active_trips": "No active Jastiper trips right now.",
    "dash.no_open_requests": "No open buyer requests right now.",
    "dash.no_orders_title": "No orders yet",
    "dash.no_orders_desc": "Browse Jastiper trips or post your own request to start.",
    "dash.no_shipments_title": "No shipments yet",
    "dash.no_shipments_desc": "Post a trip or accept buyer requests to start earning.",
    "dash.browse_trips": "Browse Trips",
    "dash.post_request": "Post Request",
    "dash.create_trip": "Create Trip",
    "dash.browse_requests": "Browse Requests",
    "dash.loading": "Loading dashboard...",
    "dash.offer": "Offer",
    "dash.from": "From",
    "dash.item": "item",
    "dash.items": "items",
    // ─── Order Statuses ─────────────────────────
    "order.status.pending_payment": "PENDING PAY",
    "order.status.paid": "PAID",
    "order.status.purchased": "PURCHASED",
    "order.status.shipping": "SHIPPING",
    "order.status.arrived": "ARRIVED",
    "order.status.delivered": "DELIVERED",
    "order.status.released": "COMPLETED",
    "order.status.cancelled": "CANCELLED",
    "order.status.refunded": "REFUNDED",
    "order.status.dispute_refunded": "REFUNDED",
    "order.status.disputed": "DISPUTED",
    "order.role.buyer": "Buyer",
    "order.role.jastiper": "Jastiper",
    "order.more": "more",
    // ─── Request statuses ────────────────────────
    "req.status.pending_price": "Set Price",
    "req.status.priced": "Awaiting Buyer",
    "req.status.agreed": "Agreed",
    "req.status.declined": "Declined",
    // ─── Common ──────────────────────────────────
    "common.loading": "Loading...",
    "common.save": "Save",
    "common.saving": "Saving...",
    "common.back": "Back",
    "common.cancel": "Cancel",
    "common.delete": "Delete",
    "common.edit": "Edit",
    "common.submit": "Submit",
    "common.search": "Search",
    "common.filter": "Filter",
    "common.all": "All",
    "common.countries": "All Countries",
    "common.location": "Location",
    "common.from": "From",
    "common.to": "To",
    "common.total": "Total",
    "common.theme_light": "Light mode",
    "common.theme_dark": "Dark mode",
    "common.language": "Language",
    // ─── Trips ───────────────────────────────────
    "trips.active_trips": "Active Trips",
    "trips.post_your_trip": "Post Your Trip",
    "trips.browse_desc": "Browse Jastipers traveling now and order from their catalog.",
    "trips.no_trips": "No trips found",
    "trips.origin": "Origin",
    "trips.filter_by_origin": "Filter by origin location",
    "trips.close_trip": "Close Trip",
    "trips.past_trip": "Past",
    "trips.new_trip": "New",
    // ─── Catalog (master) ────────────────────────
    "catalog.label": "My Catalog",
    "catalog.title": "Reusable Items",
    "catalog.desc": "Save items here once — reuse on every trip.",
    "catalog.add_item": "Add Item",
    "catalog.add_to_catalog": "Add to Catalog",
    "catalog.edit_item": "Edit Item",
    "catalog.name_placeholder": "Item name *",
    "catalog.price_placeholder": "Base Price (IDR) *",
    "catalog.country_placeholder": "Country (optional)",
    "catalog.desc_placeholder": "Short description",
    "catalog.fee_label": "Jastiper Fee — Your Earnings per Item",
    "catalog.fee_desc": "This fee is added to the Base Price above. Buyer will see Base Price + Fee as the final price.",
    "catalog.fee_fixed": "Fixed (IDR)",
    "catalog.fee_percent": "Percentage (%)",
    "catalog.fee_fixed_placeholder": "e.g. 50000",
    "catalog.fee_percent_placeholder": "e.g. 10",
    "catalog.base_price_row": "Base Price",
    "catalog.plus_jastiper_fee": "+ Jastiper Fee",
    "catalog.final_price_row": "Final price to buyer",
    "catalog.profit_calc": "Profit Calculator",
    "catalog.profit_calc_hint": "(optional · private · not saved)",
    "catalog.profit_calc_desc": "Helps you set sell price. Cost & margin are stored only in your browser — never sent to server, never visible to anyone.",
    "catalog.cost_label": "Buy Cost (Private)",
    "catalog.cost_placeholder": "e.g. 75000",
    "catalog.sell_label": "Sell Price (from Price field)",
    "catalog.profit_amount": "Gross Profit",
    "catalog.profit_margin": "Margin (% of sell price)",
    "catalog.profit_markup": "Markup (% of cost)",
    "catalog.after_platform_fee": "After platform fee {pct}%, you receive ≈ {amount}",
    "catalog.hide_price_label": "Hide price",
    "catalog.hide_price_desc": "Buyer must request to see this price",
    "catalog.no_items_title": "No items yet",
    "catalog.no_items_desc": "Add items you frequently shop for. Pick them when creating trips.",
    "catalog.add_first": "Add First Item",
    "catalog.save_changes": "Save Changes",
    "catalog.your_catalog_empty": "Your catalog is empty",
    "catalog.add_your_first_item": "Add Your First Item",
    "catalog.country_filter": "Country filter:",
    "catalog.all_count": "All ({count})",
    "catalog.no_country_chip": "No country",
    "catalog.no_items_for": "No items for",
    "catalog.show_all": "Show all",
    "catalog.private_badge": "Private",
    "catalog.hide_price_on": "Price Hidden",
    "catalog.hide_price_off": "Price Public",
    "catalog.hide_price_on_desc": "Buyer must click 'Request Quote' to see the price. Useful for anti-price-war.",
    "catalog.hide_price_off_desc": "Price is shown publicly. Buyer can directly 'Add to Cart'.",
    "trips.not_found": "Trip not found",
    "trips.notes_label": "Trip Note",
    "trips.departs_from": "departs from",
    "trips.signin_to_order": "Sign in to order",
    "trips.your_trip": "This is your own trip.",
    "trips.manage_catalog": "Manage Trip Catalog",
    "trips.manage_catalog_items": "Manage Trip Catalog ({count} items)",
    "trips.add_new_to_master": "+ Add new item to master catalog",
    "trips.pick_items_for_trip": "Pick items for this trip",
    "trips.no_master_items": "You don't have any items in your master catalog yet.",
    "trips.open_my_catalog": "Open My Catalog",
    "trips.trip_destination_country_badge": "Trip Destination",
    "trips.no_country": "No Country",
    "trips.items_selected_of": "{sel}/{total} selected",
    "trips.items_count_selected": "{count} items selected",
    "trips.platform_fee": "Platform Fee",
    "trips.cancel_trip": "Cancel Trip",
    "trips.cancel_trip_title": "Cancel this trip?",
    "trips.cancel_trip_warning": "This will cancel ALL active orders for this trip and notify each buyer.",
    "trips.cancel_reason_label": "Reason for cancellation",
    "trips.cancel_reason_placeholder": "e.g., Visa rejected, family emergency, illness...",
    "trips.cancel_trip_refund_note": "Paid orders will be marked as refund_pending. Admin will process refund to each buyer's bank account.",
    "trips.confirm_cancel_trip": "Yes, Cancel Trip",
    "trips.trip_cancelled_label": "TRIP CANCELLED",
    "trips.fee_for_buyer": "For Buyer",
    "trips.fee_for_jastiper": "For Jastiper",
    "trips.fee_split_note": "Buyer fee is added to the buyer's total. Jastiper fee is deducted from jastiper's payout.",
    // ─── Trip Owner Orders Summary ───────────────
    "trip.orders.title": "Incoming Orders for This Trip",
    "trip.orders.active_count": "{active} active orders",
    "trip.orders.total_count": "of {total} total",
    "trip.orders.none": "No orders for this trip yet.",
    "trip.orders.tab_aggregated": "Shopping List",
    "trip.orders.tab_by_buyer": "By Buyer ({count})",
    "trip.orders.aggregated_desc": "Total items to buy at destination. Auto-summed from all buyers (cancelled orders excluded).",
    "trip.orders.all_cancelled": "All orders for this trip were cancelled.",
    "trip.orders.qty_total": "qty total",
    "trip.orders.per_unit": "per item",
    "trip.orders.from_buyers": "from {count} buyer(s)",
    "trip.orders.total_buyer_paid": "Total buyer paid",
    // ─── Export menu ─────────────────────────────
    "export.shopping_list": "Export Shopping List",
    "export.pdf": "PDF (.pdf)",
    "export.excel": "Excel (.xlsx)",
    "export.whatsapp": "Share via WhatsApp",
    "export.print": "Print",
    "export.failed": "Export failed",
    // ─── Leaderboard (Iter 26) ───────────────────
    "leaderboard.label": "Referral Leaderboard",
    "leaderboard.title": "Top Referrers",
    "leaderboard.desc": "See who's earning the most by inviting friends. Climb the ranks by sharing your code.",
    "leaderboard.your_rank": "Your rank",
    "leaderboard.no_code_yet": "Set up your code in Profile",
    "leaderboard.friends": "friends",
    "leaderboard.friends_short": "friends",
    "leaderboard.tx_short": "tx",
    "leaderboard.this_month": "This Month",
    "leaderboard.all_time": "All Time",
    "leaderboard.empty": "No referrals yet this period. Be the first!",
    "leaderboard.cta_create_code": "Create my referral code",
    "leaderboard.climb_label": "Climb the leaderboard",
    "leaderboard.climb_desc": "Share your code with more friends to earn more and rank higher.",
    "leaderboard.go_to_profile": "Go to Profile",
    "leaderboard.nav_link": "Leaderboard",
    "leaderboard.disabled_msg": "Leaderboard is currently disabled by admin.",
    // ─── Hero / Landing ──────────────────────────
    "hero.tagline": "Personal Shopping · Escrow Protected",
    "hero.heading_jastip": "Jastip",
    "hero.heading_safe": "safe",
    "hero.heading_protected": "Protected by Escrow",
    "hero.desc": "Shop items from overseas without worry. Your payment is held by the platform until goods arrive safely — no funds vanish.",
    "hero.cta_unified": "Start Jastip Now",
    "hero.cta_dashboard": "Go to Dashboard",
    "hero.unified_hint": "1 account = Buyer + Jastiper",
    "hero.stat_transactions": "Transactions",
    "hero.stat_volume": "Protected",
    "hero.stat_community": "Community",
    "hero.stat_running": "Success & Running",
    "hero.stat_volume_sub": "Total Volume",
    "hero.escrow_badge": "Escrow Protected · Anti-Fraud",
    "landing.how_label": "How It Works",
    "landing.how_title": "Four safe steps.",
    "landing.how_desc": "Your funds never go directly to the Jastiper. The platform holds everything until done.",
    "landing.step1_title": "Buyer Pays",
    "landing.step1_desc": "Buyer deposits price + service fee to the platform via Midtrans (or other supported methods).",
    "landing.step2_title": "Funds in Escrow",
    "landing.step2_desc": "The platform holds funds in an escrow account. Jastiper only sees you've paid — not the money itself.",
    "landing.step3_title": "Jastiper Shops",
    "landing.step3_desc": "Jastiper buys the item, uploads Purchase Receipt, then ships to you with tracking notes.",
    "landing.step4_title": "Funds Released",
    "landing.step4_desc": "You confirm the goods arrived correctly. Funds auto-release to the Jastiper, minus a 2% platform fee.",
    "landing.trust_label": "Trust",
    "landing.trust_title": "Safe, proven.",
    "landing.badge_escrow": "Escrow Protected",
    "landing.badge_escrow_sub": "Funds held by platform",
    "landing.badge_encryption": "256-bit Encryption",
    "landing.badge_encryption_sub": "HTTPS · HSTS · bcrypt",
    "landing.badge_antibrute": "Anti-Brute Force",
    "landing.badge_antibrute_sub": "Auto-lockout after 5 tries",
    "landing.badge_antifraud": "Anti-Fraud",
    "landing.badge_antifraud_sub": "OTP + Admin review",
    "landing.badge_payment": "Secure Payment",
    "landing.badge_payment_sub": "Midtrans-certified gateway",
    "landing.featured_label": "Running Now",
    "landing.featured_title": "Active Jastiper trips.",
    "landing.featured_desc": "Browse Jastipers traveling now.",
    "landing.view_all_trips": "View All →",
    "landing.privacy_label": "Privacy Mode",
    "landing.privacy_title": "Anti price-war.",
    "landing.privacy_desc": "Jastipers can hide prices from the public. Serious buyers can request a private quote — negotiations stay between you two, not visible to competitors.",
    "landing.privacy_bullet1": "Hide prices per item or for the whole catalog",
    "landing.privacy_bullet2": "Private 1-on-1 negotiation, no peeking from other Jastipers",
    "landing.privacy_bullet3": "Setting in Profile — change anytime",
    "landing.privacy_chip": "Private Item",
    "landing.privacy_card_title": "Designer Bag · Tokyo",
    "landing.privacy_card_price": "Price:",
    "landing.privacy_card_cta": "Request Quote",
    "landing.cta_today": "Start Today",
    "landing.cta_title": "Ready to shop worry-free?",
    "landing.cta_desc": "Join {n} users who already trust their transactions to Jastip-Safe.",
  },
  id: {
    // ─── Navigation ──────────────────────────────
    "nav.dashboard": "Dasbor",
    "nav.trips": "Trip",
    "nav.find_trips": "Cari Trip",
    "nav.my_trips": "Trip Saya",
    "nav.requests": "Permintaan",
    "nav.browse_requests": "Lihat Permintaan",
    "nav.my_requests": "Permintaan Saya",
    "nav.catalog": "Katalog Saya",
    "nav.admin": "Konsol Admin",
    "nav.sign_in": "Masuk",
    "nav.sign_out": "Keluar",
    "nav.profile": "Profil",
    // ─── Bottom Nav ──────────────────────────────
    "bnav.home": "Beranda",
    "bnav.trips": "Trip",
    "bnav.requests": "Permintaan",
    "bnav.catalog": "Katalog",
    // ─── Auth ────────────────────────────────────
    "auth.welcome_back": "Selamat datang kembali",
    "auth.create_account": "Buat Akun",
    "auth.join": "Bergabung Jastip-Safe",
    "auth.sign_in": "Masuk",
    "auth.email": "Email",
    "auth.password": "Kata Sandi",
    "auth.full_name": "Nama Lengkap",
    "auth.phone": "Nomor HP",
    "auth.location": "Lokasi Asal (Kota/Provinsi)",
    "auth.referral_label": "Kode Referral (opsional)",
    "auth.referral_placeholder": "contoh: andi-jastip",
    "auth.unified_note": "Satu akun = Pembeli DAN Jastiper. Anda bisa ganti mode kapan saja dari header setelah login.",
    "auth.creating": "Membuat...",
    "auth.signing_in": "Masuk...",
    "auth.no_account": "Belum punya akun?",
    "auth.already_account": "Sudah punya akun?",
    "auth.create_one": "Buat akun",
    "auth.otp_title": "Masukkan kode OTP",
    "auth.otp_sent_to": "Kode dikirim ke",
    "auth.verify_continue": "Verifikasi & Lanjut",
    "auth.back_login": "Kembali ke login",
    "auth.privacy_label": "Default Tampilan Harga Katalog",
    "auth.privacy_public": "Publik",
    "auth.privacy_public_desc": "Harga terlihat",
    "auth.privacy_hide": "Sembunyikan Harga",
    "auth.privacy_hide_desc": "Anti perang harga",
    "auth.privacy_hint": "Bisa diubah kapan saja di Profil.",
    "auth.password_hint": "Minimal 8 karakter, mengandung huruf dan angka.",
    "auth.password_strong": "kuat",
    "auth.password_weak": "kurang kuat",
    "auth.fill_all": "Mohon isi semua field",
    "auth.password_invalid": "Password minimal 8 karakter, mengandung huruf dan angka",
    "auth.otp_sent": "OTP terkirim! Gunakan kode 123456 (mode demo)",
    "auth.register_failed": "Pendaftaran gagal",
    "auth.welcome_user": "Selamat datang,",
    "auth.login_failed": "Login gagal",
    "auth.account_verified": "Akun terverifikasi!",
    "auth.otp_wrong": "Kode OTP salah",
    "auth.superadmin_q": "Superadmin platform?",
    "auth.login_admin": "Login Admin",
    "auth.verifying": "Memverifikasi...",
    "auth.demo_mode_note": "MODE DEMO — OTP adalah:",
    // ─── Dashboard ───────────────────────────────
    "dash.welcome": "Selamat datang kembali",
    "dash.hello": "Halo",
    "dash.signed_in_as": "Masuk sebagai",
    "dash.mode_buyer": "Pembeli",
    "dash.mode_jastiper": "Jastiper",
    "dash.new_trip": "Trip Baru",
    "dash.new_request": "Permintaan Baru",
    "dash.active_buys": "Pembelian Aktif",
    "dash.total_buys": "Total Pembelian",
    "dash.open_requests": "Permintaan Terbuka",
    "dash.trips_available": "Trip Tersedia",
    "dash.active_shipping": "Pengiriman Aktif",
    "dash.active_trips": "Trip Aktif",
    "dash.your_trips": "Trip Anda",
    "dash.my_active_trips": "Trip Aktif Saya",
    "dash.my_active_trips_desc": "Klik trip untuk lihat detail & kelola katalog item-nya.",
    "dash.no_my_trips": "Belum ada trip aktif. Buat trip pertama Anda.",
    "dash.trip_active_badge": "Aktif",
    "dash.manage_catalog_arrow": "Kelola katalog →",
    "dash.pending_earnings": "Pendapatan Tertunda",
    "dash.total_earned": "Total Pendapatan",
    "dash.my_orders": "Pesanan Saya",
    "dash.shipping": "Pengiriman",
    "dash.discover": "Jelajahi",
    "dash.earn": "Cari Cuan",
    "dash.discover_trips": "Jastiper yang sedang travel",
    "dash.discover_trips_desc": "Jelajahi trip aktif dan pesan dari katalog mereka.",
    "dash.discover_requests": "Permintaan Pembeli Terbuka",
    "dash.discover_requests_desc": "Terima permintaan dan mulai berbelanja untuk pembeli.",
    "dash.view_all": "Lihat semua",
    "dash.no_active_trips": "Belum ada trip Jastiper aktif saat ini.",
    "dash.no_open_requests": "Belum ada permintaan pembeli yang terbuka.",
    "dash.no_orders_title": "Belum ada pesanan",
    "dash.no_orders_desc": "Jelajahi trip Jastiper atau posting permintaan Anda sendiri untuk mulai.",
    "dash.no_shipments_title": "Belum ada pengiriman",
    "dash.no_shipments_desc": "Posting trip atau terima permintaan pembeli untuk mulai cuan.",
    "dash.browse_trips": "Cari Trip",
    "dash.post_request": "Posting Permintaan",
    "dash.create_trip": "Buat Trip",
    "dash.browse_requests": "Lihat Permintaan",
    "dash.loading": "Memuat dasbor...",
    "dash.offer": "Penawaran",
    "dash.from": "Dari",
    "dash.item": "item",
    "dash.items": "item",
    // ─── Order Statuses ─────────────────────────
    "order.status.pending_payment": "MENUNGGU BAYAR",
    "order.status.paid": "DIBAYAR",
    "order.status.purchased": "DIBELI",
    "order.status.shipping": "DIKIRIM",
    "order.status.arrived": "SAMPAI",
    "order.status.delivered": "SAMPAI",
    "order.status.released": "SELESAI",
    "order.status.cancelled": "DIBATALKAN",
    "order.status.refunded": "DIREFUND",
    "order.status.dispute_refunded": "DIREFUND",
    "order.status.disputed": "BERMASALAH",
    "order.role.buyer": "Pembeli",
    "order.role.jastiper": "Jastiper",
    "order.more": "lainnya",
    // ─── Request statuses ────────────────────────
    "req.status.pending_price": "Beri Harga",
    "req.status.priced": "Menunggu Pembeli",
    "req.status.agreed": "Disepakati",
    "req.status.declined": "Ditolak",
    // ─── Common ──────────────────────────────────
    "common.loading": "Memuat...",
    "common.save": "Simpan",
    "common.saving": "Menyimpan...",
    "common.back": "Kembali",
    "common.cancel": "Batal",
    "common.delete": "Hapus",
    "common.edit": "Edit",
    "common.submit": "Kirim",
    "common.search": "Cari",
    "common.filter": "Filter",
    "common.all": "Semua",
    "common.countries": "Semua Negara",
    "common.location": "Lokasi",
    "common.from": "Dari",
    "common.to": "Ke",
    "common.total": "Total",
    "common.theme_light": "Mode terang",
    "common.theme_dark": "Mode gelap",
    "common.language": "Bahasa",
    // ─── Trips ───────────────────────────────────
    "trips.active_trips": "Trip Aktif",
    "trips.post_your_trip": "Posting Trip",
    "trips.browse_desc": "Jelajahi Jastiper yang sedang travel dan pesan dari katalog mereka.",
    "trips.no_trips": "Tidak ada trip ditemukan",
    "trips.origin": "Asal",
    "trips.filter_by_origin": "Filter berdasarkan lokasi asal",
    "trips.close_trip": "Tutup Trip",
    "trips.past_trip": "Selesai",
    "trips.new_trip": "Baru",
    // ─── Catalog (master) ────────────────────────
    "catalog.label": "Katalog Saya",
    "catalog.title": "Item yang Dapat Dipakai Ulang",
    "catalog.desc": "Simpan item di sini sekali — pakai ulang di setiap trip.",
    "catalog.add_item": "Tambah Item",
    "catalog.add_to_catalog": "Tambah ke Katalog",
    "catalog.edit_item": "Edit Item",
    "catalog.name_placeholder": "Nama item *",
    "catalog.price_placeholder": "Harga Modal (IDR) *",
    "catalog.country_placeholder": "Negara (opsional)",
    "catalog.desc_placeholder": "Deskripsi singkat",
    "catalog.fee_label": "Jastiper Fee — Cuan Anda per Item",
    "catalog.fee_desc": "Cuan ini ditambahkan ke Harga Modal di atas. Buyer akan melihat Harga Modal + Fee sebagai harga jual final.",
    "catalog.fee_fixed": "Nominal (IDR)",
    "catalog.fee_percent": "Persentase (%)",
    "catalog.fee_fixed_placeholder": "contoh: 50000",
    "catalog.fee_percent_placeholder": "contoh: 10",
    "catalog.base_price_row": "Harga Modal",
    "catalog.plus_jastiper_fee": "+ Jastiper Fee",
    "catalog.final_price_row": "Harga jual ke buyer",
    "catalog.profit_calc": "Kalkulator Profit",
    "catalog.profit_calc_hint": "(opsional · rahasia · tidak disimpan)",
    "catalog.profit_calc_desc": "Bantu Anda menetapkan harga jual. Modal & margin hanya tersimpan di browser Anda — tidak dikirim ke server, tidak terlihat oleh siapa pun.",
    "catalog.cost_label": "Harga Modal (Rahasia)",
    "catalog.cost_placeholder": "contoh: 75000",
    "catalog.sell_label": "Harga Jual (dari field Price)",
    "catalog.profit_amount": "Profit Kotor",
    "catalog.profit_margin": "Margin (% dari harga jual)",
    "catalog.profit_markup": "Markup (% dari modal)",
    "catalog.after_platform_fee": "Setelah dipotong fee platform {pct}%, Anda terima ≈ {amount}",
    "catalog.hide_price_label": "Sembunyikan harga",
    "catalog.hide_price_desc": "Pembeli harus request untuk melihat harga ini",
    "catalog.no_items_title": "Belum ada item",
    "catalog.no_items_desc": "Tambah item yang sering Anda jastip. Pilih saat membuat trip.",
    "catalog.add_first": "Tambah Item Pertama",
    "catalog.save_changes": "Simpan Perubahan",
    "catalog.your_catalog_empty": "Katalog Anda masih kosong",
    "catalog.add_your_first_item": "Tambah Item Pertama Anda",
    "catalog.country_filter": "Filter negara:",
    "catalog.all_count": "Semua ({count})",
    "catalog.no_country_chip": "Tanpa Negara",
    "catalog.no_items_for": "Tidak ada item untuk",
    "catalog.show_all": "Tampilkan semua",
    "catalog.private_badge": "Privat",
    "catalog.hide_price_on": "Harga Disembunyikan",
    "catalog.hide_price_off": "Harga Publik",
    "catalog.hide_price_on_desc": "Pembeli harus klik 'Minta Penawaran' untuk melihat harga. Cocok untuk anti-perang harga.",
    "catalog.hide_price_off_desc": "Harga ditampilkan di publik. Pembeli bisa langsung 'Tambah ke Keranjang'.",
    "trips.not_found": "Trip tidak ditemukan",
    "trips.notes_label": "Catatan Trip",
    "trips.departs_from": "berangkat dari",
    "trips.signin_to_order": "Masuk untuk memesan",
    "trips.your_trip": "Ini trip Anda sendiri.",
    "trips.manage_catalog": "Kelola Katalog Trip",
    "trips.manage_catalog_items": "Kelola Katalog Trip ({count} item)",
    "trips.add_new_to_master": "+ Tambah item baru ke katalog master",
    "trips.pick_items_for_trip": "Pilih item untuk trip ini",
    "trips.no_master_items": "Anda belum punya item di katalog master.",
    "trips.open_my_catalog": "Buka Katalog Saya",
    "trips.trip_destination_country_badge": "Tujuan Trip",
    "trips.no_country": "Tanpa Negara",
    "trips.items_selected_of": "{sel}/{total} dipilih",
    "trips.items_count_selected": "{count} item dipilih",
    "trips.platform_fee": "Fee Platform",
    "trips.cancel_trip": "Batalkan Trip",
    "trips.cancel_trip_title": "Batalkan trip ini?",
    "trips.cancel_trip_warning": "Ini akan membatalkan SEMUA order aktif untuk trip ini dan memberi tahu setiap pembeli.",
    "trips.cancel_reason_label": "Alasan pembatalan",
    "trips.cancel_reason_placeholder": "contoh: Visa ditolak, urusan keluarga mendadak, sakit...",
    "trips.cancel_trip_refund_note": "Order yang sudah dibayar akan ditandai refund_pending. Admin akan memproses pengembalian dana ke rekening bank masing-masing buyer.",
    "trips.confirm_cancel_trip": "Ya, Batalkan Trip",
    "trips.trip_cancelled_label": "TRIP DIBATALKAN",
    "trips.fee_for_buyer": "Untuk Pembeli",
    "trips.fee_for_jastiper": "Untuk Jastiper",
    "trips.fee_split_note": "Fee Pembeli ditambahkan di total bayar. Fee Jastiper dipotong dari penghasilan jastiper.",
    // ─── Trip Owner Orders Summary ───────────────
    "trip.orders.title": "Pesanan Masuk untuk Trip Ini",
    "trip.orders.active_count": "{active} order aktif",
    "trip.orders.total_count": "dari {total} total",
    "trip.orders.none": "Belum ada pesanan untuk trip ini.",
    "trip.orders.tab_aggregated": "Daftar Belanja",
    "trip.orders.tab_by_buyer": "Per Buyer ({count})",
    "trip.orders.aggregated_desc": "Total barang yang harus Anda beli di tujuan. Otomatis menjumlahkan qty dari semua buyer (kecuali order dibatalkan).",
    "trip.orders.all_cancelled": "Semua order untuk trip ini dibatalkan.",
    "trip.orders.qty_total": "qty total",
    "trip.orders.per_unit": "per item",
    "trip.orders.from_buyers": "dari {count} buyer",
    "trip.orders.total_buyer_paid": "Total buyer bayar",
    // ─── Export menu ─────────────────────────────
    "export.shopping_list": "Export Daftar Belanja",
    "export.pdf": "PDF (.pdf)",
    "export.excel": "Excel (.xlsx)",
    "export.whatsapp": "Bagikan via WhatsApp",
    "export.print": "Print / Cetak",
    "export.failed": "Gagal export",
    // ─── Leaderboard (Iter 26) ───────────────────
    "leaderboard.label": "Papan Peringkat Referral",
    "leaderboard.title": "Top Referrer",
    "leaderboard.desc": "Lihat siapa yang paling banyak earn dengan mengajak teman. Naikkan peringkat dengan bagikan kode Anda.",
    "leaderboard.your_rank": "Peringkat Anda",
    "leaderboard.no_code_yet": "Buat kode di Profil",
    "leaderboard.friends": "teman",
    "leaderboard.friends_short": "teman",
    "leaderboard.tx_short": "tx",
    "leaderboard.this_month": "Bulan Ini",
    "leaderboard.all_time": "Sepanjang Masa",
    "leaderboard.empty": "Belum ada referral di periode ini. Jadi yang pertama!",
    "leaderboard.cta_create_code": "Buat kode referral saya",
    "leaderboard.climb_label": "Naikkan peringkat Anda",
    "leaderboard.climb_desc": "Bagikan kode Anda ke lebih banyak teman untuk earn lebih banyak dan naik peringkat.",
    "leaderboard.go_to_profile": "Buka Profil",
    "leaderboard.nav_link": "Papan Peringkat",
    "leaderboard.disabled_msg": "Papan peringkat saat ini dimatikan oleh admin.",
    // ─── Hero / Landing ──────────────────────────
    "hero.tagline": "Personal Shopping · Dilindungi Escrow",
    "hero.heading_jastip": "Jastip",
    "hero.heading_safe": "aman",
    "hero.heading_protected": "Dilindungi Escrow",
    "hero.desc": "Belanja barang dari mancanegara tanpa khawatir. Pembayaran Anda ditahan platform sampai barang sampai dengan selamat — tidak ada dana yang menguap.",
    "hero.cta_unified": "Mulai Jastip Sekarang",
    "hero.cta_dashboard": "Ke Dasbor",
    "hero.unified_hint": "1 akun = Pembeli + Jastiper",
    "hero.stat_transactions": "Transaksi",
    "hero.stat_volume": "Dilindungi",
    "hero.stat_community": "Komunitas",
    "hero.stat_running": "Sukses & Berjalan",
    "hero.stat_volume_sub": "Total Volume",
    "hero.escrow_badge": "Escrow Protected · Anti-Fraud",
    "landing.how_label": "Cara Kerja",
    "landing.how_title": "Empat langkah aman.",
    "landing.how_desc": "Dana Anda tidak pernah langsung pergi ke Jastiper. Platform yang pegang sampai semua beres.",
    "landing.step1_title": "Pembeli Bayar",
    "landing.step1_desc": "Pembeli setor harga + biaya jasa ke platform melalui Midtrans (atau metode lain yang kami support).",
    "landing.step2_title": "Dana di-Escrow",
    "landing.step2_desc": "Platform menahan dana di rekening escrow. Jastiper hanya melihat bahwa Anda sudah membayar — bukan menerima uangnya.",
    "landing.step3_title": "Jastiper Belanja",
    "landing.step3_desc": "Jastiper membeli barangnya, unggah Bukti Pembelian, lalu kirim ke Anda dengan keterangan tracking.",
    "landing.step4_title": "Dana Dilepas",
    "landing.step4_desc": "Anda konfirmasi barang sampai dengan benar. Dana otomatis dilepas ke Jastiper, dipotong fee platform 2%.",
    "landing.trust_label": "Kepercayaan",
    "landing.trust_title": "Aman, terbukti.",
    "landing.badge_escrow": "Escrow Protected",
    "landing.badge_escrow_sub": "Dana ditahan platform",
    "landing.badge_encryption": "256-bit Encryption",
    "landing.badge_encryption_sub": "HTTPS · HSTS · bcrypt",
    "landing.badge_antibrute": "Anti-Brute Force",
    "landing.badge_antibrute_sub": "Auto-lockout 5 percobaan",
    "landing.badge_antifraud": "Anti-Fraud",
    "landing.badge_antifraud_sub": "Verifikasi OTP + Admin review",
    "landing.badge_payment": "Secure Payment",
    "landing.badge_payment_sub": "Midtrans-certified gateway",
    "landing.featured_label": "Sedang Berjalan",
    "landing.featured_title": "Trip Jastiper aktif.",
    "landing.featured_desc": "Jelajahi Jastiper yang sedang travel sekarang.",
    "landing.view_all_trips": "Lihat Semua →",
    "landing.privacy_label": "Privacy Mode",
    "landing.privacy_title": "Anti perang harga.",
    "landing.privacy_desc": "Jastiper dapat menyembunyikan harga dari publik. Pembeli yang serius dapat meminta penawaran private — negosiasi hanya terlihat antara Anda berdua, bukan ke pesaing.",
    "landing.privacy_bullet1": "Sembunyikan harga per item atau seluruh katalog",
    "landing.privacy_bullet2": "Negosiasi private 1-on-1 tanpa intip dari Jastiper lain",
    "landing.privacy_bullet3": "Setting di Profil — bisa diubah kapan saja",
    "landing.privacy_chip": "Private Item",
    "landing.privacy_card_title": "Designer Bag · Tokyo",
    "landing.privacy_card_price": "Harga:",
    "landing.privacy_card_cta": "Minta Penawaran",
    "landing.cta_today": "Mulai Hari Ini",
    "landing.cta_title": "Siap belanja tanpa was-was?",
    "landing.cta_desc": "Gabung {n} pengguna yang sudah percayakan transaksi mereka ke Jastip-Safe.",
  },
};

const I18nContext = createContext(null);

export const I18nProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("jastip_lang") || "id");

  useEffect(() => {
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("jastip_lang", lang);
  }, [lang]);

  // t(key) → translated string. Supports {n}-style interpolation via t(key, {n: 10}).
  const t = (key, params) => {
    let str = STRINGS[lang]?.[key] ?? STRINGS.en[key] ?? key;
    if (params && typeof str === "string") {
      Object.keys(params).forEach((k) => {
        str = str.replace(new RegExp(`\\{${k}\\}`, "g"), String(params[k]));
      });
    }
    return str;
  };

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
};

export const useI18n = () =>
  useContext(I18nContext) || { t: (k) => k, lang: "en", setLang: () => {} };
